import React from 'react'
import Button from 'material-ui/Button'
import Grid from 'material-ui/Grid'
import Icon from 'material-ui/Icon'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'

import ConfirmDialog from '../../common/dialog/confirm'
import styles from './styles'

class Privacy extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      confirmationOpen: false,
      processing: false,
      processingBusinessDays: 10,
      submitted: false,
      failed: false
    }
  }

  componentDidMount() {
    this.props.getSettings()
      .then(settings => {
        if (settings && settings.processingBusinessDays) {
          this.setState({ processingBusinessDays: settings.processingBusinessDays })
        }
      })
      .catch(() => this.setState({ failed: true }))
  }

  openConfirmation = () => {
    this.setState({ confirmationOpen: true, failed: false })
  }

  closeConfirmation = () => {
    if (!this.state.processing) {
      this.setState({ confirmationOpen: false })
    }
  }

  submitRequest = () => {
    if (this.state.processing) {
      return
    }

    this.setState({ processing: true, failed: false })
    this.props.submitRequest()
      .then(response => {
        this.setState({
          confirmationOpen: false,
          processing: false,
          processingBusinessDays: response.processingBusinessDays || this.state.processingBusinessDays,
          submitted: true
        })
      })
      .catch(() => {
        this.setState({
          confirmationOpen: false,
          processing: false,
          failed: true
        })
      })
  }

  render() {
    const { classes, impersonating, translate, user } = this.props
    const {
      confirmationOpen,
      failed,
      processing,
      processingBusinessDays,
      submitted
    } = this.state
    const email = user && user.email ? user.email : ''

    return (
      <Paper className={classes.paper}>
        <Grid container spacing={16} alignItems="flex-start">
          <Grid item>
            <div className={classes.iconContainer}>
              <Icon className={classes.icon}>security</Icon>
            </div>
          </Grid>
          <Grid item xs>
            <Typography type="title" gutterBottom>
              {translate('gdpr_data_title')}
            </Typography>
            <Typography type="body1" className={classes.description}>
              {translate('gdpr_data_description')}
            </Typography>
            <Typography type="body1" className={classes.process}>
              {translate('gdpr_data_process', { days: processingBusinessDays })}
            </Typography>

            {submitted && (
              <Typography type="body1" className={classes.success}>
                {translate('gdpr_request_success')}
              </Typography>
            )}
            {failed && (
              <Typography type="body1" className={classes.error}>
                {translate('gdpr_request_error')}
              </Typography>
            )}
            {impersonating && (
              <Typography type="body1" className={classes.notice}>
                {translate('gdpr_request_impersonation_disabled')}
              </Typography>
            )}

            <Button
              className={classes.requestButton}
              onClick={this.openConfirmation}
              disabled={impersonating || processing || submitted}
            >
              <Icon className={classes.buttonIcon}>file_download</Icon>
              {translate('gdpr_request_button')}
            </Button>
          </Grid>
        </Grid>

        <ConfirmDialog
          open={confirmationOpen}
          title={translate('gdpr_confirm_title')}
          contentText={translate('gdpr_confirm_text', {
            days: processingBusinessDays,
            email: email
          })}
          contentSecondaryText={translate('gdpr_confirm_secondary')}
          yesText={processing ? translate('gdpr_request_sending') : translate('gdpr_submit_request')}
          noText={translate('general_cancel')}
          processing={processing}
          onYes={this.submitRequest}
          onNo={this.closeConfirmation}
          onCancel={this.closeConfirmation}
        />
      </Paper>
    )
  }
}

export default withStyles(styles)(Privacy)
